import DefaultLayout from "../layouts/defaultLayout";

const layouts = {
  default: DefaultLayout,
};

export default layouts;
